module.exports = __webpack_public_path__ + "static/media/ic-admin-btn-edit.eb56c30d.svg";